module.exports = __webpack_public_path__ + "img/welsknight-1c826966-c965-4489-48a2-08d95b7e528f.png";